import type { ComponentType } from "react";
import { User, Clock, Check } from "lucide-react";

import { AllisonOrb } from "@/components/alia/allison-orb";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { Channel, ConversationStatus } from "@/types";

const CHANNEL_LABEL: Record<Channel, string> = {
  web: "Web",
  whatsapp: "WhatsApp",
  instagram: "Instagram",
  telegram: "Telegram",
};

const CHANNEL_DOT: Record<Channel, string> = {
  web: "bg-channel-web",
  whatsapp: "bg-channel-whatsapp",
  instagram: "bg-channel-instagram",
  telegram: "bg-channel-telegram",
};

export function ChannelBadge({ channel }: { channel: Channel }) {
  return (
    <Badge variant="muted" className="gap-1.5 font-normal">
      <span className={cn("size-1.5 rounded-full", CHANNEL_DOT[channel])} />
      {CHANNEL_LABEL[channel]}
    </Badge>
  );
}

const STATUS_CONFIG: Record<
  Exclude<ConversationStatus, "ai">,
  {
    label: string;
    icon: ComponentType<{ className?: string }>;
    variant: "warning" | "success" | "muted";
  }
> = {
  waiting: { label: "Esperando", icon: Clock, variant: "warning" },
  human: { label: "Humano", icon: User, variant: "muted" },
  resolved: { label: "Resuelto", icon: Check, variant: "success" },
};

export function StatusPill({ status }: { status: ConversationStatus }) {
  if (status === "ai") {
    return (
      <Badge variant="brand" className="gap-1.5 pl-1">
        <AllisonOrb size={14} active />
        Allison
      </Badge>
    );
  }

  const config = STATUS_CONFIG[status];
  const Icon = config.icon;
  return (
    <Badge variant={config.variant} className="gap-1">
      <Icon className="size-3" />
      {config.label}
    </Badge>
  );
}
